import React from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import {
    Descriptions,
    Badge,
    Typography,
    Popconfirm,
    Icon,
    Button,
} from "antd";
import {
    API_REQUESTS_STATUS_TYPES,
    API_REQUESTS_TYPES,
    COMPARISON_VALIDITY_STATUS,
} from "../../../constants";
import { Text3, Text4 } from "../../../styles";
import { printRupee } from "../../../app_methods";
import moment from "moment";
import "./index.scss";

const APIRequestInfo = (props) => {
    const APIRequest = props.APIRequest || {};


    return (
        <EaseDrawer
            className="api-request-details-wrapper"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={500}
        >
            <Typography.Title className="mt-4" level={4}>
                Verification Details
            </Typography.Title>
            <Descriptions
                className="mt-4"
                title={false}
                column={1}
                bordered
                size="small"
            >
                <Descriptions.Item label="Status">
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <Badge
                            color={
                                APIRequest.status
                                    ? API_REQUESTS_STATUS_TYPES[
                                          APIRequest.status
                                      ].color
                                    : ""
                            }
                            text={
                                <Text4>
                                    {APIRequest.status
                                        ? API_REQUESTS_STATUS_TYPES[
                                              APIRequest.status
                                          ].label
                                        : "---"}
                                </Text4>
                            }
                        />
                    </div>
                </Descriptions.Item>
                <Descriptions.Item label="Response Status">
                    {APIRequest?.response_status ? APIRequest?.response_status : "---" }
                </Descriptions.Item>
                <Descriptions.Item label="URN">{APIRequest.merchant_request_number || "---"}</Descriptions.Item>
                <Descriptions.Item label="Verification Type">{APIRequest.api_type?API_REQUESTS_TYPES[APIRequest.api_type].label:"---"}</Descriptions.Item>
                { APIRequest?.api_type !="GSTIN_VERIFICATION"? 
                        <Descriptions.Item label="Name">{APIRequest.name || "---"}</Descriptions.Item>
               :null}
                <Descriptions.Item label="Created At">{APIRequest.created_at && moment(APIRequest.created_at).format("LLL")}</Descriptions.Item>
                {
                    APIRequest.api_type == "VPA_VERIFICATION_API" ?
                        <Descriptions.Item label="UPI Handle">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.upi_handle || "---": "---"}</Descriptions.Item>
                        :null
                }
                 {
                    APIRequest.api_type == "PAN_VERIFICATION" ?
                    <>
                        <Descriptions.Item label="PAN">{APIRequest.response_payload?APIRequest.response_payload?.processed_response?.pan_number || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Date of Birth">{APIRequest.response_payload?APIRequest.response_payload?.processed_response?.dob || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Father's Name">{APIRequest.response_payload?APIRequest.response_payload?.processed_response?.father_name || "---": "---"}</Descriptions.Item>
                        </> :null
                }
                {
                    APIRequest.api_type == "GSTIN_VERIFICATION" ?
                    <>
                        <Descriptions.Item label="GSTIN">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.gstin || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="GSTIN Status">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.gstin_status || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Legal Name of Business">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.legalname_of_business || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Constitution of Business">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.constitution_of_business || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Tradename of Business">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.tradename_of_business || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Centre Jurisdiction">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.centre_jurisdiction || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="State Jurisdiction">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.state_jurisdiction || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Registration Date">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.registration_date || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="E-invoicing Status">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.e_invoicing_status || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Principal Place Address">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.principal_place_address || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Principal Place City">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.principal_place_city || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Principal Place State">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.principal_place_state || "---": "---"}</Descriptions.Item>
                        <Descriptions.Item label="Principal Place Pincode">{APIRequest.response_payload?APIRequest.response_payload.processed_response?.principal_place_pincode || "---": "---"}</Descriptions.Item>
                        </>
                        :null
                }
                {
                    APIRequest.api_type == "PENNY_DROP_API" ?
                        <>
                            <Descriptions.Item label="Account Number">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.account_number || "---": "---"}</Descriptions.Item>
                            <Descriptions.Item label="IFSC Code">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.account_ifsc?.toUpperCase() || "---":"---"}</Descriptions.Item>
                        </>:null
                }
                {
                    APIRequest.api_type === "PENNY_DROP_FUZZY_API" ?
                        <>
                            <Descriptions.Item label="Account Number">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.account_number || "---": "---"}</Descriptions.Item>
                            <Descriptions.Item label="IFSC Code">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.account_ifsc?.toUpperCase() || "---":"---"}</Descriptions.Item>
                            <Descriptions.Item label="Input Name">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.account_holder_name || "---":"---"}</Descriptions.Item>
                            {APIRequest?.response_payload.percentage_match >= 0 ? (
                                <>
                                <Descriptions.Item label="Comparison Validity">
                                    <Badge color={COMPARISON_VALIDITY_STATUS[APIRequest?.response_payload?.is_matched]?.color}
                                           text={<Text4> {COMPARISON_VALIDITY_STATUS[APIRequest?.response_payload?.is_matched]?.label} </Text4>}/>
                                </Descriptions.Item>
                                <Descriptions.Item label="Threshold Percentage">{`${APIRequest.request_payload && APIRequest.request_payload.merchant_request.threshold_percentage ? (APIRequest.request_payload.merchant_request.threshold_percentage+"%") || "---": "---"}`}</Descriptions.Item>
                                <Descriptions.Item label="Comparison Percentage">{`${APIRequest?.response_payload.percentage_match}%`}</Descriptions.Item>
                                </>
                            ): null}
                            
                        </>:null
                }
                {
                    APIRequest.api_type == "BANK_STATUS" ?<>
                        <Descriptions.Item label="Bank Name">{APIRequest.response_payload?APIRequest.response_payload.raw_response.bank_name|| "---":"---"}</Descriptions.Item>
                        <Descriptions.Item label="IFSC Code">{APIRequest.request_payload?APIRequest.request_payload.merchant_request.ifsc?.toUpperCase() || "---":"---"}</Descriptions.Item>
                        </>:null
                }
                <Descriptions.Item label="Platform Charges">
                    {APIRequest.status == "success" && APIRequest.is_valid
                        ? printRupee(APIRequest?.service_charge)
                        : printRupee(0)}
                </Descriptions.Item>

                <Descriptions.Item label="GST Amount">
                    {APIRequest.status == "success" && APIRequest.is_valid
                        ? printRupee(APIRequest?.gst_amount)
                        : printRupee(0)}
                </Descriptions.Item>

                <Descriptions.Item label="Total">
                    {APIRequest.status == "success" && APIRequest.is_valid
                        ? printRupee(APIRequest?.service_charge_with_gst)
                        : printRupee(0)}
                </Descriptions.Item>
            </Descriptions>
        </EaseDrawer>
    );
};

export { APIRequestInfo };
